import React, { useEffect } from 'react'
import {
  Box,
  Typography,
  Paper,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useDispatch, useSelector } from 'react-redux'
import { getRewardPayments } from '@/actions/admin'

export default function Rewards({ profileID = '' }) {
  const dispatch = useDispatch()
  const isLoading = useSelector((state) => state.admin.isLoading)
  const rewardPayments = useSelector((state) => state.admin.rewardPayments)

  useEffect(() => {
    dispatch(getRewardPayments(profileID))
  }, [profileID])

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Reward Payments
      </Typography>
      {rewardPayments?.map((entry, i) => {
        const program = entry.reward_program
        const payouts = entry.payouts

        return (
          <Box mt={3}>
            <Accordion key={i} defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">{program.name}</Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Box
                  p={3}
                  border={1}
                  borderColor="grey.300"
                  borderRadius={2}
                  mb={1}
                >
                  <Typography variant="subtitle1">
                    Description: {program.description}
                  </Typography>
                  <Typography variant="body2">
                    Period: {program.period}
                  </Typography>
                  <Typography variant="body2">
                    Amount: {program.amount}
                  </Typography>
                </Box>

                {payouts.map((payout) => (
                  <Paper
                    key={payout.id}
                    variant="outlined"
                    sx={{ p: 2, mb: 2, backgroundColor: 'grey.50' }}
                  >
                    <Typography>
                      <strong>Payout ID:</strong> {payout.id}
                    </Typography>
                    <Typography>
                      <strong>Date:</strong>{' '}
                      {new Date(payout.created).toLocaleDateString()}
                    </Typography>
                    <Typography>
                      <strong>Status:</strong> {payout.status}
                    </Typography>
                    {payout.ineligibility_reason && (
                      <Typography color="error">
                        <strong>Ineligibility Reason:</strong>{' '}
                        {payout.ineligibility_reason}
                      </Typography>
                    )}

                    {payout.transaction ? (
                      <>
                        <Divider sx={{ my: 1 }} />
                        <Typography>
                          <strong>Transaction ID:</strong>{' '}
                          {payout.transaction.id}
                        </Typography>
                        <Typography>
                          <strong>Transaction Created:</strong>{' '}
                          {new Date(
                            payout.transaction.created,
                          ).toLocaleDateString()}
                        </Typography>
                        <Typography>
                          <strong>Transaction Points:</strong>{' '}
                          {payout.transaction.points}
                        </Typography>
                        <Typography>
                          <strong>Transaction Type:</strong>{' '}
                          {payout.transaction.type}
                        </Typography>
                        <Typography>
                          <strong>Transaction Status:</strong>{' '}
                          {payout.transaction.status}
                        </Typography>
                      </>
                    ) : (
                      <Typography color="text.secondary">
                        No transaction for payout
                      </Typography>
                    )}
                  </Paper>
                ))}
              </AccordionDetails>
            </Accordion>
          </Box>
        )
      })}
    </Box>
  )
}
